import React from "react"
import {withFormik} from 'formik';
import {FormattedMessage, injectIntl} from "react-intl";
import {displayErrors, parsePropertiesErrors} from "../../../../form-helpers";
import BaseComponent from "../../../base-component";

class Page1 extends BaseComponent {

    constructor(params) {
        super(params);
    }

    render() {
        const { intl, values, touched, errors, handleChange, handleBlur, handleSubmit, submitForm, isSubmitting, setFieldValue, isComplete } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <h3><FormattedMessage id='app.personal_forms.page_1.title'/></h3>
                <p><FormattedMessage id='app.personal_forms.page_1.info'/></p>
                <p><FormattedMessage id='app.personal_forms.message.required_fields'/> (<span className='text-red'>*</span>)</p>
                <hr/>
                { displayErrors(errors, 'base') }
                <div className='row'>
                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.salutation'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <select disabled={isComplete} type="text" className='form-control' id='data.salutation' value={values.data.salutation} onChange={handleChange}>
                                <option value=''>-</option>
                                { this.props.constants.codes.salutations.map((salute) => (<option key={salute.key} value={salute.key}>{salute.value}</option>)) }
                            </select>
                            { displayErrors(errors, 'data.salutation') }
                        </div>
                    </div>

                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.title_before_name'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <select disabled={isComplete} type="text" className='form-control' id='data.title_before_name' value={values.data.title_before_name} onChange={handleChange}>
                                <option value=''>-</option>
                                {this.props.constants.codes.personal_titles.map((personal_title) => (<option key={personal_title.key} value={personal_title.key}>{personal_title.value}</option>))}
                            </select>
                            {displayErrors(errors, 'data.title_before_name')}
                        </div>
                    </div>

                    <div className='col-md-4'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.title_after_name'>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                            <select disabled={isComplete} type="text" className='form-control' id='data.title_after_name' value={values.data.title_after_name} onChange={handleChange}>
                                <option value=''>-</option>
                                {this.props.constants.codes.personal_titles.map((personal_title) => (<option key={personal_title.key} value={personal_title.key}>{personal_title.value}</option>))}
                            </select>
                            {displayErrors(errors, 'data.title_after_name')}
                        </div>
                    </div>

                </div>
                <div className='row'>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.name'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.name' value={values.data.name} onChange={handleChange}/>
                            { displayErrors(errors, 'data.name') }
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.surname'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.surname' value={values.data.surname} onChange={handleChange}/>
                            { displayErrors(errors, 'data.surname') }
                        </div>
                        <div className='form-group'>
                            <FormattedMessage id='app.personal_forms.attribute.former_surname'>{(txt) => (<label className={'required-field'}>{txt}</label>)}</FormattedMessage>
                            <input disabled={isComplete} type="text" className='form-control' id='data.former_surname' value={values.data.former_surname} onChange={handleChange}/>
                            <div className='shift small text-muted'><FormattedMessage id={'app.personal_forms.attribute.former_surname.info'}/></div>
                            { displayErrors(errors, 'data.former_surname') }
                        </div>
                    </div>
                </div>

                <div className='clearfix'>
                    <hr/>
                    { !isComplete && <button type='submit' className='btn btn-primary float-right' disabled={isSubmitting}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}{this.spinner(isSubmitting)}</button> }
                    { isComplete && <button type='button' className='btn btn-primary float-right' onBlur={handleBlur} onClick={this.props.next}>{intl.formatMessage({id: 'app.personal_forms.buttons.next_step'})}</button> }
                </div>
            </form>
        )
    }

}

export default injectIntl(withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => {
        let model = { data: { ...props.resource.data, page: 2 } };
        return model;
    },
    handleSubmit: (values, form) => { form.props.submit(values, form); },
    displayName: 'BasicForm',
})(Page1));
